export default __webpack_public_path__ + "media/zurb/img/case-study-cartpros/cartpros-img1-3e1eca69c41bc65ee8e58fe9105d631d.jpg";